import React, { useState, useEffect } from "react";
import { Card, Row, Col, Space, Flex, Button, Form, Input, Image } from 'antd';
import { MailOutlined, CommentOutlined, PhoneOutlined, PushpinOutlined, SyncOutlined } from '@ant-design/icons';
import { API } from '../components/Initilization'
import { useNotificationContext } from '../components/NotificationContext'
import "../assets/css/contact-us.css"


const ContactUs = () => {
  useEffect(() => {

    RefreshCaptcha()
  }, []);

  const [Captcha, setCaptcha] = useState("");
  const notif = useNotificationContext();

  const RefreshCaptcha = () => {
    API.get('/api/company/create-captcha')
      .then(function (response) {
        if (response.status == 200) {
          setCaptcha("data:image/png;base64, " + response.data.CaptchaImg)
        }
      })
      .catch((error) => console.log(error));
  };

  const onContactUsFormSubmit = (values) => {
    var bodyFormData = new FormData();
    bodyFormData.append("FullName", values.FullName)
    bodyFormData.append("MobileNumber", values.MobileNumber)
    bodyFormData.append("Email", values.Email)
    bodyFormData.append("Text", values.Text)
    bodyFormData.append("Captcha", document.getElementById("Captcha").value)
        API.post('/api/company/create-contact-us', bodyFormData)
  .then((response)=> {
    debugger;
    if (response.status == 200 && response.data.ResultCode == 200) {

                        notif.open({
            type: 'success',
            style: { width: "450px" },
            className: "fYekan-bold",
            placement: 'topRight',
            message: 'موفق',
            description: 'پیام شما با موفقیت ثبت شد',
          });
          setTimeout(function(){
            window.location.href = "/"
          },2000)

    }
    RefreshCaptcha()
})
    .catch((error) => {
      RefreshCaptcha()
    });
  };


  return (

    <>

      <Flex align="center" justify="center" >
        <Row className="mt-4 mb-5" gutter={[24, 24]} style={{ padding: "10px", marginRight: "0px", marginLeft: "0px", alignItems: "stretch" }}>
          <Col xs={{ span: 24 }} xl={{ span: 6 }} md={{ span: 12 }}>
            <div style={{ minWidth: "290px" }} className="card glass-effect shadow-3 shaped-border p-2 pt-4 pb-4 same-height-card">

              <Flex align="center" justify="center">

                <Button type="primary" className="m-2 mt-0 contact-us-icon" size="large" shape="circle">
                  <PushpinOutlined style={{ fontSize: "40px" }} />
                </Button>


              </Flex>
              <Flex className="pt-3 pb-3" align="center" justify="center">
                <span className="fYekan-bold purple-text-lighten-4 font-6">آدرس</span>
              </Flex>
              <br />
              <Flex align="center" justify="center">
                <span style={{ textAlign: "center" }} className="fYekan purple-text-lighten-4 font-3 line-height-1px">
                  تبریز - جاده آذرشهر - روبروی کارخانه دونار - آقای چاپ
                </span>
              </Flex>



            </div>
          </Col>
          <Col xs={{ span: 24 }} xl={{ span: 6 }} md={{ span: 12 }}>
            <div style={{ minWidth: "290px" }} className="card glass-effect shadow-3 shaped-border p-2 pt-4 pb-4 same-height-card">

              <Flex align="center" justify="center">

                <Button type="primary" className="m-2 mt-0 contact-us-icon" size="large" shape="circle">
                  <MailOutlined style={{ fontSize: "40px" }} />
                </Button>


              </Flex>
              <Flex className="pt-3 pb-3" align="center" justify="center">
                <span className="fYekan-bold purple-text-lighten-4 font-6">ایمیل</span>
              </Flex>
              <br />
              <Flex align="center" justify="center">
                <span style={{ textAlign: "center" }} className="fYekan purple-text-lighten-4 font-4 line-height-1px">
                  info@mrchap-co.ir
                  <br />
                  support@mrchap-co.ir
                </span>
              </Flex>



            </div>
          </Col>
          <Col xs={{ span: 24 }} xl={{ span: 6 }} md={{ span: 12 }}>
            <div style={{ minWidth: "290px" }} className="card glass-effect shadow-3 shaped-border p-2 pt-4 pb-4 same-height-card">

              <Flex align="center" justify="center">

                <Button type="primary" className="m-2 mt-0 contact-us-icon" size="large" shape="circle">
                  <PhoneOutlined style={{ fontSize: "40px" }} />
                </Button>


              </Flex>
              <Flex className="pt-3 pb-3" align="center" justify="center">
                <span className="fYekan-bold purple-text-lighten-4 font-6">شماره تماس</span>
              </Flex>
              <br />
              <Flex align="center" justify="center">
                <span style={{ textAlign: "center" }} className="fYekan purple-text-lighten-4 font-4 line-height-1px">
                  0936-836-1943
                  <br />
                  0904-458-1151
                </span>
              </Flex>



            </div>
          </Col>
          <Col xs={{ span: 24 }} xl={{ span: 6 }} md={{ span: 12 }}>
            <div style={{ minWidth: "290px" }} className="card glass-effect shadow-3 shaped-border p-2 pt-4 pb-4 same-height-card">

              <Flex align="center" justify="center">

                <Button type="primary" className="m-2 mt-0 contact-us-icon" size="large" shape="circle">
                  <CommentOutlined style={{ fontSize: "40px" }} />
                </Button>

              </Flex>
              <Flex className="pt-3 pb-3" align="center" justify="center">
                <span className="fYekan-bold purple-text-lighten-4 font-6">شبکه های اجتماعی</span>
              </Flex>
              <br />
              <Flex align="center" justify="center">
                <span style={{ textAlign: "center" }} className="fYekan purple-text-lighten-4 font-3 line-height-1px">
                  <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                    <i className="fa fa-telegram"></i>
                  </Button>
                  <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                    <i className="fa fa-instagram"></i>
                  </Button>
                  <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                    <i className="fa fa-whatsapp"></i>
                  </Button>
                </span>
              </Flex>



            </div>
          </Col>
        </Row>
      </Flex>

      <Row align={"center"}>
        <Col span={24} style={{ maxWidth: "1200px" }}>

          <Card
            className="fYekan light-glass-effect-card shaped-border"
            title="تماس با آقای چاپ"
            
          >

            <Flex align="center" justify="center">
              <Form onFinish={onContactUsFormSubmit} style={{width:"100%"}}
                layout="vertical"  
                className="fEstedad"  
              >
                <Row gutter={[24,0]}>
                  <Col span={24} lg={12}>
                  <Form.Item label="نام و نام خانوادگی" name="FullName">  
                  <Input />  
                </Form.Item>  
                  </Col>
                  <Col span={24} lg={12}>
                  <Form.Item label="شماره همراه" name="MobileNumber">  
                  <Input style={{ direction: "ltr", height:"40px", paddingTop:"0px" }} prefix={<p style={{ marginTop:"22px" }}> +98 </p> } />  
                </Form.Item>  
                  </Col>
                  <Col span={24} lg={12}>
                  <Form.Item label="ایمیل" name="Email">  
                  <Input style={{ direction: "ltr" }} />  
                </Form.Item>  
                  </Col>
                  <Col span={24} lg={12}>
                  <Form.Item style={{ position: "relative", direction:"ltr" }} label="کپچا" name="Captcha">
                    <Image style={{ position: "absolute", top: "-13px", left: "3px", width: "102px", zIndex: "50", borderRadius: "8px" }} src={Captcha} />
                    <Input id="Captcha" style={{paddingTop:"0px", height:"40px"}} prefix={<SyncOutlined onClick={RefreshCaptcha} style={{ cursor: "pointer" }} />} />
                  </Form.Item>
                  </Col>
                  <Col span={24} >
                  <Form.Item label="متن پیام" name="Text">  
                  <Input.TextArea rows={3} />
                </Form.Item>  
                  </Col>
                  
                  </Row>  
                  
                <Form.Item>  
                  <Space size={"large"} style={{ width: '100%', justifyContent: 'center' }}>  
                    <Button htmlType="submit" type="primary">ثبت پیام</Button>  
                  </Space>  
                </Form.Item>  

              </Form>
              </Flex>  

          </Card>

        </Col>
      </Row>



    </>
  );
};

export default ContactUs;  